export default person => [person.firstName, person.lastName].filter(name => !!name).join(' ');
